import { Outlet, NavLink, useParams } from 'react-router'

const tabs = [
  { path: 'settings', label: 'الإعدادات' },
  { path: 'categories', label: 'الفئات' },
  { path: 'scoring-config', label: 'التقييم' },
  { path: 'participants', label: 'المشاركون' },
  { path: 'judges', label: 'المحكّمون' },
  { path: 'live', label: 'البث المباشر' },
  { path: 'results', label: 'النتائج' },
  { path: 'audit', label: 'السجل' },
]

export function CompetitionTabsLayout(): React.ReactElement {
  const { id } = useParams<{ id: string }>()

  return (
    <div>
      {/* Tab strip */}
      <nav className="-mx-4 mb-6 flex gap-0.5 overflow-x-auto px-4 scrollbar-hide md:mx-0 md:px-0">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={`/admin/competitions/${id}/${tab.path}`}
            className={({ isActive }) =>
              `whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-all duration-100 md:px-4 ${
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted/60 hover:text-foreground'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  )
}
